import appLocaleData from 'react-intl/locale-data/fa';
import saMessages from '../locales/es_ES.json';

const saLang = {
  messages: {
    ...saMessages
  },
  locale: 'es',
  data: appLocaleData
};
export default saLang;
